import React, {Suspense, lazy} from 'react';
import {Spin} from 'antd';
import {ROUTE_MR_ASSIST} from '../../RoutePathConstant';
import {authLoader} from '../../loader';

const MrAssist = lazy(() =>
  import('../../../screens/MrAssist')
    .then(module => ({default: module.MrAssist})));

const MrAssistNavigation = [
  {
    path: ROUTE_MR_ASSIST,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <MrAssist />
      </Suspense>
    ),
  },
];

export default MrAssistNavigation;
